import { default as IntersectionObserverView } from './component/index.web';
export default IntersectionObserverView;
